import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/components/ui/tooltip';

export function HeaderAlerts() {
  const { t } = useTranslation('layout');

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-label={t('header.alerts.label')}
          className="relative"
        >
          <AlertTriangle className="w-5 h-5" />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-warning rounded-full ring-2 ring-background" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>{t('header.alerts.label')}</TooltipContent>
    </Tooltip>
  );
}
